module.exports = __webpack_public_path__ + "img/CB0000_rabbit_stroke.65c07515.png";